import { motion } from "framer-motion";
import whatsapp from "../../assets/images/wpbg.png";

const WhatsAppButton = () => {
  const isMobile = window.innerWidth < 768;

  return (
    <motion.a
      href="https://wa.me/919650237131"
      target="_blank"
      rel="noreferrer"
      whileTap={{ scale: 0.9 }}
      style={{
        position: "fixed",
        bottom: isMobile ? "20px" : "30px",
        right: isMobile ? "20px" : "30px",
        zIndex: 2000,
        padding: "6px", // improves touch without changing look
        borderRadius: "50%",
      }}
    >
      <img
        src={whatsapp}
        alt="WhatsApp"
        style={{
          width: "55px",
          height: "55px",
          display: "block",
        }}
      />
    </motion.a>
  );
};

export default WhatsAppButton;
